module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4_EE-bd608d0bf4c45cb8ce39c7160531720b.svg";